import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import Switch from '@material-ui/core/Switch';
import FilledInput from '@material-ui/core/FilledInput';
import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';
import FormLabel from '@material-ui/core/FormLabel';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import PlacesAutocomplete from 'react-places-autocomplete';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Hidden from '@material-ui/core/Hidden';

import {
  classTypes,
  days,
  startTimes,
  endTimes,
  timezones,
  languages,
  orderings,
  attendanceTypes,
} from '../../../shared/Mappings';

import {
  getTimezoneObjectByCode,
  currentTimeInTimezone,
  getTimezoneNameByCode,
} from '../../../shared/Helpers';

const drawerWidth = 420;
const drawerWidthMobile = 330;

const styles = theme => ({
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 18px',
    ...theme.mixins.toolbar,
  },
  drawerPaper: {
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    width: drawerWidthMobile,
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
    },
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0,
  },
  listDivider: {
    marginBottom: theme.spacing(),
  },
  toolbarDivider: {
    // backgroundColor: 'rgba(0, 0, 0, 0.42)',
  },
  loadingSpinnerContainer: {
    display: 'flex',
    height: '100%',
    marginTop: theme.spacing(4),
    justifyContent: 'center',
  },
  formControl: {
    display: 'flex',
    marginBottom: theme.spacing(2),
  },
  dateFieldLeft: {
    marginRight: theme.spacing(),
  },
  dateFieldRight: {
    marginLeft: theme.spacing(),
  },
  dateGroup: {
    paddingTop: theme.spacing(),
  },
  form: {
    padding: theme.spacing(2),
  },
  buttonContainer: {
    paddingTop: theme.spacing(),
    textAlign: 'right',
    paddingRight: theme.spacing(2),
  },
  button: {
    marginRight: theme.spacing(),
    marginLeft: theme.spacing(),
  },
  query: {
    backgroundColor: 'white',
    paddingBottom: theme.spacing(),
  },
  inputAdornment: {
    paddingTop: theme.spacing(),
  },
  timezoneGroup: {
    // paddingLeft: theme.spacing(),
    // paddingRight: theme.spacing(),
  },
  timezoneButton: {
    paddingBottom: theme.spacing(),
  },
  selectedPageSize: {
    backgroundColor: theme.palette.primary.dark,
  },
  pageSizeFormControl: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
});


class ListSearchPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {
      classes,
      open,
      handleDrawerClose,
      handleDrawerOpen,
      handleViewToggle,
      checked,
      handleClassTypeChange,
      currentClassType,
      handleStartTimeChange,
      startTime,
      handleEndTimeChange,
      endTime,
      handleResetSearch,
      currentDay,
      handleDayChange,
      instructor,
      handleQueryChange,
      timezone,
      handleTimezoneChange,
      handleMakeQuery,
      loading,
      handleKeyDown,
      attendanceType,
      handleAttendanceTypeChange,
      language,
      handleLanguageChange,
      showTimezoneField,
      handleShowTimezoneFieldChange,
      ordering,
      handleOrderChange,
      pageSize,
      handlePageSizeChange,
      handleDummyQuery,
      address,
      handleLocationChange,
      handleLocationSelect,
      queryHasChanged,
    } = this.props;

    const today = new Date().getDay();
    const sortDisabled = address === '';

    const drawer = (
      <React.Fragment>
        <div className={classes.toolbarIcon}>
          <Grid component="label" container alignItems="center" spacing={0}>
            <Grid item>
              <Typography>List View</Typography>
            </Grid>
            <Grid item>
              <Switch
                checked={checked}
                onChange={e => handleViewToggle(e)}
                value="checked"
                color="default"
              />
            </Grid>
            <Grid item>
              <Typography>Map View</Typography>
            </Grid>
          </Grid>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider className={classes.toolbarDivider} color="textPrimary" />
        <form onSubmit={handleDummyQuery}>
          {/* TEACHER SEARCH */}
          <FilledInput
            className={classes.query}
            value={instructor}
            onChange={handleQueryChange}
            placeholder="Search Instructor Name"
            onKeyDown={e => handleKeyDown(e)}
            fullWidth
            endAdornment={(
              <InputAdornment className={classes.inputAdornment} position="end">
                <IconButton
                  onClick={handleMakeQuery}
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            )}
          />
          <div className={classes.form}>
            {/* ATTENDANCE RADIOS */}
            <FormControl fullWidth component="fieldset" className={classes.formControl}>
              <FormLabel color="secondary" component="legend">Online/In-Person</FormLabel>
              <RadioGroup row aria-label="attendance" name="attendance" value={attendanceType} onChange={handleAttendanceTypeChange}>
                {attendanceTypes.map(theAttendanceType => (<FormControlLabel key={theAttendanceType.code} value={theAttendanceType.code} control={<Radio color="secondary" />} label={theAttendanceType.name} />))}
              </RadioGroup>
            </FormControl>
            {/* CLASS TYPE */}
            <FormControl fullWidth className={classes.formControl}>
              <FormLabel color="secondary" htmlFor="class-type-native-helper">Class Type</FormLabel>
              <NativeSelect
                fullWidth
                value={currentClassType}
                onChange={e => handleClassTypeChange(e)}
                input={<Input name="class type" id="class-type-native-helper" style={{ marginTop: 8 }} />}
              >
                {classTypes.map(theClassType => <option key={theClassType.code} value={theClassType.code}>{theClassType.name}</option>)}
              </NativeSelect>
            </FormControl>
            {/* DAY */}
            <FormControl fullWidth className={classes.formControl}>
              <FormLabel color="secondary" htmlFor="day-native-helper">Day</FormLabel>
              <NativeSelect
                fullWidth
                value={currentDay}
                onChange={e => handleDayChange(e)}
                input={<Input name="day" id="day-native-helper" style={{ marginTop: 8 }} />}
              >
                {days.map((day, i) => <option key={day} value={i}>{(i === today) ? '(Today) ' + day : day}</option>)}
              </NativeSelect>
            </FormControl>
            {/* TIMES */}
            {currentDay !== 0
              && (
                <React.Fragment>
                  <FormLabel component="legend">Starts Between Times</FormLabel>
                  <FormGroup row className={classes.dateGroup}>
                    {/* START */}
                    <FormControl className={classes.formControl}>
                      <InputLabel color="secondary">Range Start</InputLabel>
                      <NativeSelect
                        className={classes.dateFieldLeft}
                        value={startTime}
                        onChange={e => handleStartTimeChange(e)}
                        input={<Input name="start time" id="start-time-native-helper" />}
                      >
                        {startTimes.map((time, i) => <option key={time} value={i}>{time}</option>)}
                      </NativeSelect>
                    </FormControl>
                    {/* END */}
                    <FormControl>
                      <InputLabel color="secondary">Range End</InputLabel>
                      <NativeSelect
                        label="Range End"
                        className={classes.dateFieldRight}
                        value={endTime}
                        onChange={e => handleEndTimeChange(e)}
                        input={<Input name="end time" id="end-time-native-helper" />}
                      >
                        {endTimes.map((time, i) => <option key={time} value={i}>{time}</option>)}
                      </NativeSelect>
                    </FormControl>
                  </FormGroup>
                </React.Fragment>
              )
            }
            {/* LANGUAGE */}
            <FormControl fullWidth className={classes.formControl}>
              <FormLabel color="secondary" htmlFor="class-type-native-helper">Language</FormLabel>
              <NativeSelect
                fullWidth
                value={language}
                onChange={e => handleLanguageChange(e)}
                input={<Input name="class type" id="class-type-native-helper" style={{ marginTop: 8 }} />}
              >
                {languages.map(theLanguage => <option key={theLanguage.code} value={theLanguage.code}>{theLanguage.name}</option>)}
              </NativeSelect>
            </FormControl>
            {/* TIMEZONE */}
            <div className={classes.timezoneGroup}>
              {showTimezoneField
                ? (
                  <Autocomplete
                    disableClearable
                    color="secondary"
                    value={getTimezoneObjectByCode(timezone)}
                    options={timezones}
                    getOptionLabel={option => option.name + ' (' + currentTimeInTimezone(option.code) + ')'}
                    getOptionDisabled={option => option.code === ''}
                    onChange={handleTimezoneChange}
                    renderInput={params => <TextField {...params} label="Timezone" helperText="Show class times for timezone" />}
                  />
                )
                : (
                  <Typography color="textSecondary" className={classes.timezoneButton}>
                    Your Timezone
                    <Button size="small" onClick={handleShowTimezoneFieldChange}>{getTimezoneNameByCode(timezone)}</Button>
                  </Typography>
                )
              }
            </div>
            {/* SEARCH */}
            {!loading && (
              <PlacesAutocomplete
                value={address}
                onChange={e => handleLocationChange(e)}
                onSelect={e => handleLocationSelect(e)}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  autocompleteloading,
                }) => (
                  <div>
                    <Input
                      {...getInputProps({
                        fullWidth: true,
                        placeholder: 'Search Address, City, State or Zip',
                        className: classes.locationSearchInput,
                        endAdornment: <InputAdornment position="end"><SearchIcon /></InputAdornment>,
                      })}
                    />
                    <List className={classes.autocompleteDropdownContainer}>
                      {autocompleteloading && <div key="loading">Loading...</div>}
                      {suggestions.map((suggestion) => {
                        const className = suggestion.active
                          ? classes.suggestionItemActive
                          : classes.suggestionItem;
                        return (
                          <ListItem
                            key={suggestion.placeId}
                            {...getSuggestionItemProps(suggestion, { className })}
                          >
                            <ListItemText key={suggestion.placeId}>{suggestion.description}</ListItemText>
                          </ListItem>
                        );
                      })}
                    </List>
                  </div>
                )}
              </PlacesAutocomplete>
            )}
            {/* SORT */}
            <FormControl disabled={sortDisabled} fullWidth component="fieldset" className={classes.formControl}>
              <FormLabel color="secondary" component="legend">Sort By</FormLabel>
              <RadioGroup row aria-label="attendance" name="attendance" value={ordering} onChange={handleOrderChange}>
                {orderings.map(theOrdering => <FormControlLabel key={theOrdering.code} value={theOrdering.code} control={<Radio color="secondary" />} label={theOrdering.name} />)}
              </RadioGroup>
            </FormControl>
            {/* PAGE SIZE */}
            <FormControl fullWidth className={classes.pageSizeFormControl}>
              <FormLabel color="secondary" htmlFor="class-type-native-helper">Show&nbsp;</FormLabel>
              <ButtonGroup variant="text" color="secondary" aria-label="text primary button group">
                <Button onClick={() => handlePageSizeChange('20')} className={pageSize === '20' ? classes.selectedPageSize : classes.pageSizeOption}>20</Button>
                <Button onClick={() => handlePageSizeChange('50')} className={pageSize === '50' ? classes.selectedPageSize : classes.pageSizeOption}>50</Button>
                {/*<Button onClick={() => handlePageSizeChange('100')} className={pageSize === '100' ? classes.selectedPageSize : classes.pageSizeOption}>100</Button>*/}
                {/*<Button onClick={() => handlePageSizeChange('all')} className={pageSize === 'all' ? classes.selectedPageSize : classes.pageSizeOption}>All</Button>*/}
              </ButtonGroup>
            </FormControl>
            <div className={classes.buttonContainer}>
              <Button className={classes.button} onClick={handleResetSearch}>Reset</Button>
              <Button className={classes.button} variant="contained" color="secondary" disabled={loading || !queryHasChanged} onClick={handleMakeQuery}>Search</Button>
            </div>
          </div>
        </form>
        <Divider className={classes.listDivider} />
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <Hidden lgUp>
          <SwipeableDrawer
            classes={{
              paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
            variant="temporary"
            open={open}
            onOpen={handleDrawerOpen}
            onClose={handleDrawerClose}
          >
            {drawer}
          </SwipeableDrawer>
        </Hidden>
        <Hidden smDown>
          <Drawer
            classes={{
              paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
            variant="permanent"
            open={open}
          >
            {drawer}
          </Drawer>
        </Hidden>
      </React.Fragment>
    );
  }
}

ListSearchPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  handleViewToggle: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleDrawerClose: PropTypes.func.isRequired,
  handleDrawerOpen: PropTypes.func.isRequired,
  handleClassTypeChange: PropTypes.func.isRequired,
  currentClassType: PropTypes.string.isRequired,
  handleStartTimeChange: PropTypes.func.isRequired,
  startTime: PropTypes.number.isRequired,
  handleEndTimeChange: PropTypes.func.isRequired,
  endTime: PropTypes.number.isRequired,
  instructor: PropTypes.string.isRequired,
  handleQueryChange: PropTypes.func.isRequired,
  handleResetSearch: PropTypes.func.isRequired,
  currentDay: PropTypes.number.isRequired,
  handleDayChange: PropTypes.func.isRequired,
  timezone: PropTypes.string.isRequired,
  handleTimezoneChange: PropTypes.func.isRequired,
  handleMakeQuery: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
  attendanceType: PropTypes.string.isRequired,
  handleAttendanceTypeChange: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  handleLanguageChange: PropTypes.func.isRequired,
  showTimezoneField: PropTypes.bool.isRequired,
  handleShowTimezoneFieldChange: PropTypes.func.isRequired,
  ordering: PropTypes.string.isRequired,
  handleOrderChange: PropTypes.func.isRequired,
  pageSize: PropTypes.string.isRequired,
  handlePageSizeChange: PropTypes.func.isRequired,
  handleDummyQuery: PropTypes.func.isRequired,
  address: PropTypes.string.isRequired,
  handleLocationChange: PropTypes.func.isRequired,
  handleLocationSelect: PropTypes.func.isRequired,
  queryHasChanged: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ListSearchPanel);
